import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface MenuItem {
  id: string;
  name: string;
  totalDocuments?: number;
}

interface InitialState {
  menuData: { data: MenuItem[]; status: ReduxStateType };
  subMenuData: {
    [key: string]: {
      data: MenuItem[];
      status: ReduxStateType;
      isOpen: boolean;
    };
  };
}

const initialState: InitialState = {
  menuData: {
    data: [],
    status: ReduxStateType.INIT,
  },
  subMenuData: {},
};

const menuInternalDocumentSlice = createSlice({
  name: "menuInternalDocument",
  initialState,
  reducers: {
    getMenuStart: (state) => {
      state.menuData.status = ReduxStateType.LOADING;
    },
    getMenuSuccess: (state, action: PayloadAction<MenuItem[]>) => {
      state.menuData.status = ReduxStateType.SUCCESS;
      state.menuData.data = action.payload;
    },
    getMenuFailed: (state) => {
      state.menuData.status = ReduxStateType.ERROR;
    },
    setIsOpenSubMenu: (
      state,
      action: PayloadAction<{ id: string; status: boolean }>
    ) => {
      state.subMenuData[action.payload.id] = {
        ...state.subMenuData[action.payload.id],
        isOpen: action.payload.status,
      };
    },
    getSubMenuStart: (state, action: PayloadAction<{ id: string }>) => {
      state.subMenuData[action.payload.id] = {
        status: ReduxStateType.LOADING,
        data: undefined,
        isOpen: false,
      };
    },
    getSubMenuSuccess: (
      state,
      action: PayloadAction<{ id: string; data: MenuItem[] }>
    ) => {
      state.subMenuData[action.payload.id] = {
        status: ReduxStateType.SUCCESS,
        data: action.payload.data,
        isOpen: true,
      };
    },
    getSubMenuFailed: (state, action: PayloadAction<{ id: string }>) => {
      state.subMenuData[action.payload.id] = {
        status: ReduxStateType.ERROR,
        data: undefined,
        isOpen: false,
      };
    },
    resetInternalDocumentMenu: () => {
      return { ...initialState };
    },
  },
});

export const {
  getMenuStart,
  getMenuSuccess,
  getMenuFailed,
  setIsOpenSubMenu,
  getSubMenuStart,
  getSubMenuSuccess,
  getSubMenuFailed,
  resetInternalDocumentMenu,
} = menuInternalDocumentSlice.actions;

export default menuInternalDocumentSlice.reducer;
